// Returns a boolean if a Filter.value is a valid date string
export function isValidDateString(dateString: any): boolean {
    // Check if the input is a string
    if (typeof dateString !== "string") {
        return false;
    }

    try {
        // Attempt to parse the string as a date
        const date = new Date(dateString);

        // Check if the date is valid
        return !isNaN(date.getTime());
    } catch (e) {
        // If there's any error, return false
        return false;
    }
}
